import { z } from 'zod';

const TABLE_PATH_PATTERN = /^\/workspace\/tables\/[a-f0-9]{24}\.jsonl$/;

export const renderArtifactReceiptSchema = z.object({
    component: z.enum(['table', 'shifts', 'caregivers', 'client_detail']),
    title: z.string().max(80).optional(),
    path: z
        .string()
        .regex(/^\/workspace\/(?:tables|presentations)\/[a-f0-9]{24}\.jsonl$/),
    format: z.enum(['csv', 'jsonl']),
    row_count: z.number().int().nonnegative(),
    byte_size: z.number().int().nonnegative(),
    columns: z.array(z.string().max(128)).max(64),
    columns_truncated: z.boolean(),
    content_sha256: z.string().regex(/^[a-f0-9]{64}$/),
    suggested_component: z
        .enum(['shifts', 'caregivers', 'client_detail'])
        .optional(),
    event_id: z.uuid().optional(),
    page_offsets: z.array(z.number().int().nonnegative()).max(501).optional(),
});

export const renderArtifactOutputSchema = z.object({
    render_artifact: renderArtifactReceiptSchema,
});

const tableRenderArtifactReceiptSchema = renderArtifactReceiptSchema.extend({
    component: z.literal('table'),
    title: z.string().trim().min(1).max(80).optional(),
    row_count: z.number().int().positive(),
    columns: z.array(z.string().max(128)).min(1).max(64),
});
const tableRenderArtifactOutputSchema = z.object({
    render_artifact: tableRenderArtifactReceiptSchema,
});

export type GenericTableReceipt = z.infer<
    typeof tableRenderArtifactReceiptSchema
>;

export function parseGenericTableReceipt(
    toolName: string,
    output: unknown,
): {
    readonly receipt: GenericTableReceipt;
    readonly workspacePath: string;
} | null {
    if (toolName !== 'render_dynamic_ui') {
        return null;
    }
    const parsed = tableRenderArtifactOutputSchema.safeParse(output);
    if (!parsed.success) {
        return null;
    }
    if (!TABLE_PATH_PATTERN.test(parsed.data.render_artifact.path)) {
        return null;
    }
    const receipt = parsed.data.render_artifact;
    return {
        receipt,
        workspacePath: receipt.path.slice('/workspace/'.length),
    };
}
